import { Title, createStyles, Group } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontSize: "3rem",

    [theme.fn.smallerThan("md")]: {
      fontSize: "2.5rem",
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: "2rem",
    },
  },

  group: {
    marginBottom: 48,

    [theme.fn.smallerThan("md")]: {
      marginBottom: 24,
    },
  },
}))

// ----------------------------------------------------------------------

type Props = {
  title: string
};

export function PageTitle({ title }: Props): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Group position="center" className={classes.group}>
      <Title align="center" className={classes.title}>
        {title}
      </Title>
    </Group>
  )
}
